<template>
  <NotificationTypeWrapper :notification="notification">
    <p class="my-0">
      The title <strong v-text="title" /> has been {{ updateTypeDescription }}
      <a
        :href="actionLink"
        v-text="name"
      />.
    </p>
  </NotificationTypeWrapper>
</template>

<script type="text/babel">
import NotificationTypeMixin from './NotificationTypeMixin'

export default {
  name: 'MembershipTitleHasBeenUpdatedNotification',
  mixins: [NotificationTypeMixin],
  computed: {
    title() {
      return this.notification.attributes.data.membership_title
    },
    updateTypeDescription() {
      return this.notification.attributes.data.update_type === 'added'
        ? 'assigned to '
        : 'removed from '
    },
    name() {
      return `${this.notification.attributes.data.first_name} ${this.notification.attributes.data.last_name}`
    },
    actionLink() {
      return `${this.$urlGenerator.active()}members/${this.notification.attributes.data.membership_uuid}`
    },
  },
}
</script>
